import { Icon } from "@stellar/design-system";

import { DialogModal } from "@/components/DialogModal";

import "./AboutRolesModal.scss";

type RoleRow = {
  role: string;
  description: string;
  capabilities: boolean[];
};

const MATRIX_COLUMNS = [
  "View data",
  "Create drafts",
  "Submit disbursements",
  "Manage users",
  "Technical access",
  "Can be a co-signer",
];

const MATRIX_ROWS: RoleRow[] = [
  {
    role: "Owner",
    description: "Full access",
    capabilities: [true, true, true, true, true, true],
  },
  {
    role: "Financial controller",
    description: "Can submit, no user management",
    capabilities: [true, true, true, false, false, true],
  },
  {
    role: "Approver",
    description: "Can approve and submit disbursements",
    capabilities: [true, false, true, false, false, false],
  },
  {
    role: "Read only",
    description: "View data only",
    capabilities: [true, false, false, false, false, false],
  },
  {
    role: "Developer",
    description: "Technical access only",
    capabilities: [false, false, false, false, true, false],
  },
];

interface AboutRolesModalProps {
  visible: boolean;
  onClose: () => void;
}

export const AboutRolesModal = ({ visible, onClose }: AboutRolesModalProps) => (
  <DialogModal visible={visible} onClose={onClose} title="About the roles">
    <div className="AboutRolesModal">
      <table className="AboutRolesModal__table">
        <thead>
          <tr>
            <th className="AboutRolesModal__roleCol">Role</th>
            {MATRIX_COLUMNS.map((c) => (
              <th key={c} className="AboutRolesModal__capCol">
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {MATRIX_ROWS.map((row) => (
            <tr key={row.role}>
              <td className="AboutRolesModal__roleCol">
                <div className="AboutRolesModal__roleName">{row.role}</div>
                <div className="AboutRolesModal__roleDesc">{row.description}</div>
              </td>
              {row.capabilities.map((yes, idx) => (
                <td
                  key={MATRIX_COLUMNS[idx]}
                  className="AboutRolesModal__cell"
                  aria-label={yes ? "Yes" : "No"}
                >
                  {yes ? (
                    <span className="AboutRolesModal__check" aria-hidden="true">
                      <Icon.Check />
                    </span>
                  ) : (
                    <span className="AboutRolesModal__dash" aria-hidden="true">
                      —
                    </span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </DialogModal>
);
